export default __webpack_public_path__ + "e5ef9171b308e7f1891f236dbe87fc26.png";